import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import OrderStatus from "./views/OrderStatus.vue";


Vue.use(Router);
Vue.use(require("vue-moment"));
let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/status/:email/:status",
      name: "status",
      props: true,
      component: OrderStatus
    },
    {
      path: "/about",
      name: "about",
      component: () => import("./views/About.vue")
    },
    {
      path: "/selected",
      name: "selected",
      component: () => import("./views/SelectedOffer.vue")
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login.vue")
    },
    {
      path: "/forgotpassword",
      name: "forgotPassword",
      component: () => import("./views/ForgotPassword.vue")
    },
    {
      path: "/contact",
      name: "contact",
      component: () => import("./views/Contact.vue")
    },
    {
      path: "/partner",
      name: "partner",
      component: () => import("./views/BecomePartner.vue")
    },
    {
      path: "/agent",
      name: "agent",
      component: () => import("./views/BecomeAgent.vue")
    },
    {
      path: "/account",
      name: "account",
      component: () => import("./views/Account.vue")
    },
    {
      path: "/billing/:package/:plan",
      name: "billing",
      component: () => import("./views/Billing.vue")
    },
    {
      path: "/privacy-policy",
      name: "privacyPolicy",
      component: () => import("./views/PrivacyPolicy.vue"),
    },
    {
      path: "/admin",
      name: "admin",
      component: () => import("./views/AdminHome.vue"),
      meta: { 
          requiresAuth: true,
          is_admin: true,
        }
    },
    {
        path: "/admin/requests",
        name: "admin/requests",
        component: () => import("./views/AdminRequests.vue"),
        meta: { 
            requiresAuth: true,
            is_admin: true,
          }
      },
    {
      path: "/admin/clients",
      name: "admin/clients",
      component: () => import("./views/AdminClients.vue"),
      meta: { 
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/clients/:id",
      name: "admin/clients/detail",
      component: () => import("./views/AdminUserDetail.vue"),
      meta: { 
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/trucks",
      name: "admin/trucks",
      component: () => import("./views/AdminTrucks.vue"),
      meta: { 
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/trucks/add",
      name: "admin/trucks/add",
      component: () => import("./views/AdminTrucksAdd.vue"),
      meta: { 
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/agents",
      name: "admin/agents",
      component: () => import("./views/AdminAgents.vue"),
      meta: { 
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/agents/requests",
      name: "admin/agents/requests",
      component: () => import("./views/AdminAgentRequests.vue"),
      meta: { 
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/partner/requests",
      name: "admin/partner/requests",
      component: () => import("./views/AdminPartnerRequest.vue"),
      meta: {
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/agents/requests/:id",
      name: "admin/agents/requests/detail",
      component: () => import("./views/AdminAgentRequestDetail.vue"),
      meta: { 
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/partner/requests/:id",
      name: "admin/partner/requests/detail",
      component: () => import("./views/AdminPartnerRequestDetail.vue"),
      meta: {
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/finances",
      name: "admin/finances",
      component: () => import("./views/AdminFinances.vue"),
      meta: { 
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/finances/:id",
      name: "admin/finances/detail",
      component: () => import("./views/AdminPaymentDetail.vue"),
      meta: { 
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/requests/add",
      name: "admin/requests/add",
      component: () => import("./views/AdminAddRequest.vue"),
      meta: { 
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/requests/:id",
      name: "admin/request/detail",
      component: () => import("./views/AdminRequestDetail.vue"),
      meta: { 
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/users",
      name: "admin/users",
      component: () => import("./views/AdminUsers.vue"),
      meta: { 
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/promo-codes",
      name: "admin/promo-codes",
      component: () => import("./views/AdminPromoCodes.vue"),
      meta: { 
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/promocionet",
      name: "admin/promocionet",
      component: () => import("./views/AdminAksionet.vue"),
      meta: { 
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path:"/admin/statistics/clients",
      name:"admin/statistics/clients",
      component: () => import("./views/AdminClientStatistics.vue"),
      meta:{
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/statistics/drivers",
      name: "admin/statistics/drivers",
      component: () => import("./views/AdminDriversStatistics.vue"),
      meta:{
        requiresAuth: true,
        is_admin: true,
      }
    },
    {
      path: "/admin/guest/interventions",
      name: "admin/guest/interventions",
      component: () => import('./views/GuestInterventions.vue'),
      meta: {
        requiresAuth: true,
        is_admin: true
      }
    }
  ]
});
router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) 
    {
        if (localStorage.getItem('token') == null) 
        {
            next({
                path: '/login',
                params: { nextUrl: to.fullPath }
            })
        } 
        else 
        {
            let user = JSON.parse(localStorage.getItem('user'))
            if(to.matched.some(record => record.meta.is_admin)) {
                const roles = ['superadmin', 'operations', 'finances', 'finops', 'driver'];
                if(roles.includes(user.user_type)){
                    next()
                }
                else{
                    next({ name: 'home'})
                }
            } else {
                next()
            }
        }
    } else {
        next() 
    }
})
export default router;